import React from "react";
import { NavLink, Outlet, useLocation } from "react-router-dom";
import { Users, ScrollText, Shield, Settings, Building2 } from "lucide-react";
import pt from "@/lib/i18n";

const TABS = [
    { to: "/admin/utilizadores", key: "users", icon: Users, label: pt.admin.tabs.users },
    { to: "/admin/auditoria", key: "audit", icon: ScrollText, label: pt.admin.tabs.audit },
    { to: "/admin/rbac", key: "rbac", icon: Shield, label: pt.admin.tabs.rbac },
    { to: "/admin/sistema", key: "settings", icon: Settings, label: pt.admin.tabs.settings },
    { to: "/admin/organizacao", key: "tenants", icon: Building2, label: pt.admin.tabs.tenants },
];

export const AdminLayout = () => {
    const location = useLocation();
    const current = TABS.find((t) => location.pathname.startsWith(t.to));

    return (
        <div data-testid="admin-layout">
            <div
                className="mb-7 flex items-center gap-1 p-1 rounded-xl overflow-x-auto"
                style={{
                    background: "var(--bg-elevated)",
                    border: "1px solid var(--glass-border)",
                    width: "fit-content",
                    maxWidth: "100%",
                }}
                data-testid="admin-tabs"
            >
                {TABS.map(({ to, key, icon: Icon, label }) => (
                    <NavLink
                        key={key}
                        to={to}
                        end={key === "users"}
                        className={({ isActive }) =>
                            "inline-flex items-center gap-2 px-4 py-2 rounded-lg text-sm font-body font-medium transition-all whitespace-nowrap " +
                            (isActive
                                ? "bg-[color:var(--copper)] text-white shadow-sm"
                                : "text-[color:var(--slate-mid)] hover:text-[color:var(--copper-dark)] hover:bg-[color:var(--copper-subtle)]")
                        }
                        data-testid={`admin-tab-${key}`}
                    >
                        <Icon size={15} strokeWidth={1.8} />
                        <span>{label}</span>
                    </NavLink>
                ))}
            </div>

            <div key={current?.key || "tab"}>
                <Outlet />
            </div>
        </div>
    );
};

export default AdminLayout;
